/**
 * Carrusel del hero.
 *
 * Autoavance con pausa al pasar el cursor, al enfocar con teclado y cuando
 * la pestana no esta visible. Con prefers-reduced-motion no autoavanza:
 * el usuario navega manualmente.
 */
(function () {
  if (window.__nobleHeroSliderInit) return;
  window.__nobleHeroSliderInit = true;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSlider(root) {
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    if (slides.length < 2) return;

    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    const interval = parseInt(root.dataset.interval || '6000', 10);
    let index = slides.findIndex((s) => s.classList.contains('is-active'));
    if (index < 0) index = 0;
    let timer = null;
    let paused = false;

    function show(next) {
      const n = slides.length;
      index = (next + n) % n;
      slides.forEach((s, i) => {
        // Camino mas corto: con 3 diapositivas, la que "ya paso" sale
        // por la izquierda (-1) en vez de dar toda la vuelta por la
        // derecha (+2), asi el avance se ve siempre hacia la derecha.
        let offset = i - index;
        if (offset > n / 2) offset -= n;
        if (offset < -n / 2) offset += n;
        s.style.setProperty('--slide-offset', offset);

        const active = i === index;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        // Los enlaces de una diapositiva oculta no deben ser tabulables.
        s.querySelectorAll('a, button').forEach((el) => {
          el.tabIndex = active ? 0 : -1;
        });
      });
      dots.forEach((d, i) => {
        const active = i === index;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function start() {
      if (reduced || paused || timer) return;
      timer = setInterval(() => show(index + 1), interval);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { show(i); stop(); start(); });
    });

    root.addEventListener('mouseenter', () => { paused = true; stop(); });
    root.addEventListener('mouseleave', () => { paused = false; start(); });
    root.addEventListener('focusin', () => { paused = true; stop(); });
    root.addEventListener('focusout', (e) => {
      if (!root.contains(e.relatedTarget)) { paused = false; start(); }
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop(); else start();
    });

    show(index);
    start();
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-noble-hero-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
